import { commonUtils } from '../common_utils';

const RAHOITUSTIE_MIN_LOAN_AMOUNT = 500;

export const rahoitustie = {
    removeGreenEffect() {
        $('.greenFadeEffectRahoitustie').removeClass('updateSec');
    },
    loadYear(defaultYears) {
        $('#rahoitustieLoanPeriod').empty();

        let startYear = 1,
            endYear = 7;
        for (let year = startYear; year <= endYear; year++) {
            $('#rahoitustieLoanPeriod').append(new Option(year, year));
        }

        $('#rahoitustieLoanPeriod').val(defaultYears);
    },
    slider() {
        let defaultYear = $('#rahoitustieLoanPeriod').val();
        let loanAmount = $('#rahoitustieLoanAmount').val();

        $('.greenFadeEffectRahoitustie').addClass('updateSec');

        if (loanAmount < RAHOITUSTIE_MIN_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.rahoitustie_min_loan_amount);
            loanAmount = RAHOITUSTIE_MIN_LOAN_AMOUNT;
            $('#rahoitustieLoanAmount').val(loanAmount);
        }

        rahoitustie.loadYear(defaultYear);
        defaultYear = $('#rahoitustieLoanPeriod').val();

        if (loanAmount) {
            $.ajax({
                type: 'GET',
                url: Routing.generate('finance_rahoitustie'),
                data: `loanAmount=${loanAmount}&loanPeriod=${defaultYear}`,
                success(data) {
                    let loanData = data.rahoitustie;
                    let installment = '-',
                        effective = '-',
                        nominal = '-';

                    if (loanData) {
                        installment = commonUtils.numberFormatByLocale(loanData.vahimmaisera.toFixed(2));
                        effective = commonUtils.numberFormatByLocale(loanData.todellinenvuosikorko.toFixed(2));
                        nominal = commonUtils.numberFormatByLocale(loanData.nimelliskorko.toFixed(2));
                    }

                    $('#rahoitustie_monthly_payment').html(installment);
                    $('#rahoitustie_air').html(effective);
                    $('#rahoitustie_mir').html(nominal);

                    setTimeout(rahoitustie.removeGreenEffect, 1000);
                },
            });
        }
    },
    submit(object) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent(object.data('bank-name'));
        window.open(object.find('.loanMoreInfo').data('loan-url'), '_blank');
    },
};
